import { SSOProtocol, type DomainSSOConfiguration } from './ssoTypes'

const domainSSOConfigurations: Record<string, DomainSSOConfiguration> = {
  unl: {
    domain: 'unl.dopa.ge',
    defaultAuthMethod: 'sso',
    ssoConfig: {
      protocol: SSOProtocol.SAML2,
      enabled: true,
      displayName: 'UNL SSO',
      idpUrl: 'https://shib.unl.edu/idp/profile/SAML2/Redirect/SSO',
      entityId: 'https://sso.dopa.ge',
      acsUrl: 'https://sso.dopa.ge/auth/saml/callback'
    }
  },
  studio: {
    domain: 'studio.dopa.ge',
    defaultAuthMethod: 'password',
    ssoConfig: {
      protocol: SSOProtocol.OIDC,
      enabled: true,
      displayName: 'Okta SSO',
      authority: 'https://dev-78829499.okta.com/oauth2/default',
      clientId: '0oapjq3uymzq79ArT5d7',
      redirectUri: `${window.location.origin}/auth/sso/callback`,
      scopes: ['email', 'openid', 'profile'],
      responseType: 'code'
    }
  }
  // Additional domains can be added here
}

export const getDomainSSOConfig = (domain: string): DomainSSOConfiguration | null => {
  return domainSSOConfigurations[domain] ?? null
}

export const getDefaultAuthMethod = (domain: string): 'sso' | 'password' => {
  const config = getDomainSSOConfig(domain)
  return config?.defaultAuthMethod ?? 'password'
}

export const isSSOEnabledForDomain = (domain: string): boolean => {
  const config = getDomainSSOConfig(domain)
  return config?.ssoConfig?.enabled ?? false
}

